import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ModuleService } from 'tnx-admin-service/authorization/module/services';
import { BasePermissionService } from 'tnx-admin-service/authorization/basepermission/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent, GridInfo, ModelSchema, Sort } from 'tnx-shared';

@Component({
    selector: 'basepermission',
    templateUrl: './basepermission.component.html',
    styleUrls: ['./basepermission.component.scss'],
    providers: [ComponentContextService],
})
export class BasePermissionComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};

    showImportForm = false;

    constructor(
        protected _injector: Injector,
        protected _basePermissionService: BasePermissionService,
        private _moduleService: ModuleService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._basePermissionService;
        this.setting.objectName = 'thông tin quyền';
        this.setting.fieldSearchText = ['code', 'name', 'moduleCode'];

        this.setting.modelSchemas = [
            new ModelSchema({
                field: 'name',
                name: 'Tên',
                fullName: 'Tên',
                description: 'Tên'
            }),
            new ModelSchema({
                field: 'code',
                name: 'Mã',
                fullName: 'Mã',
                description: 'Mã'
            }),
            // new ModelSchema({
            //     field: 'description',
            //     name: 'Mô tả',
            //     fullName: 'Mô tả',
            //     description: 'Mô tả'
            // }),
            new ModelSchema({
                field: 'orderNo',
                dataType: 'int',
                name: 'Thứ tự',
                fullName: 'Thứ tự',
                description: 'Thứ tự'
            }),
            new ModelSchema({
                field: 'moduleCode',
                name: 'Phân hệ',
                fullName: 'Phân hệ',
                description: 'Phân hệ'
            }),
        ];

        this.setting.cols = [
            new ColumnSchemaBase({
                field: 'name'
            }),
            new ColumnSchemaBase({
                field: 'code'
            }),
            // new ColumnSchemaBase({
            //     field: 'description'
            // }),
            new ColumnSchemaBase({
                field: 'orderNo',
                width: '100px'
            }),
            new ColumnSchemaBase({
                field: 'moduleCode',
                baseService: this._moduleService,
                displayField: 'name',
                valueField: 'code',
                forceGetData: true,
                width: '150px'
            }),
        ];

        super.ngOnInit();
    }

    async modifyGridInfo(grid: GridInfo) {
        grid.sorts.push(new Sort({
            field: 'moduleCode',
            dir: 1
        }))


        grid.sorts.push(new Sort({
            field: 'orderNo',
            dir: 1
        }))
    }

    async beforeAdd() {
        this.setting.popupSize = {
            width: 800,
            height: 500
        }
    }


    async beforeView() {
        this.setting.popupSize = {
            width: 800,
            height: 500
        }
    }

    async beforeEdit() {
        this.setting.popupSize = {
            width: 800,
            height: 500
        }
    }

    import() {
        this.setting.popupHeader = 'Import thông tin quyền'
        this.setting.popupSize = {
            width: 500,
            height: 400
        }
        this.formModel.data = {};
        this.showImportForm = true;
    }
}

